import { Component, OnInit } from '@angular/core';
import { LocalizationManagerService } from 'src/app/shared/services/localization-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-localization',
  templateUrl: './select-localization.component.html',
  styleUrls: ['./select-localization.component.scss']
})
export class SelectLocalizationComponent implements OnInit {

  public selectedValue :string;
  public allowLocalizationChange = environment.allowLocalizationChange;

  constructor(private  localizationManagerService: LocalizationManagerService) { }

  public availableLocalizations: Array<{ text: string; value: string, flag:string }> = [
    { text: "Polski", value: 'pl-PL', flag:'./assets/img/flags/pl.png' },
    { text: "English", value: 'en-GB',flag:'./assets/img/flags/gb.png' },
    { text: "Italiano", value: 'it-IT',flag:'./assets/img/flags/it.png' },
    { text: "Deutsch", value: 'de-DE',flag:'./assets/img/flags/de.png' },
    { text: "Português", value: 'pt-PT',flag:'./assets/img/flags/pt.png' },
  ];

  

  ngOnInit(): void {
    this.selectedValue = this.localizationManagerService.getCurrentLocalization();

  }

  onChange(ev:string){
    this.localizationManagerService.setCurrentLocalization(ev);
    window.location.reload();
  }

}
